const BYTES_PER_KILOBYTE = 1000
const BYTES_PER_MEGABYTE = 1000 * BYTES_PER_KILOBYTE
const BYTES_PER_GIGABYTE = 1000 * BYTES_PER_MEGABYTE

export function parseZipSize(value) {
  if (typeof value === 'number') {
    return Number.isFinite(value) && value >= 0 ? value * BYTES_PER_GIGABYTE : null
  }

  if (typeof value !== 'string') {
    return null
  }

  const match = value.trim().match(/^(\d+(?:[.,]\d+)?|[.,]\d+)\s*([kmg])?(?:b)?$/i)
  if (!match) {
    return null
  }

  const amount = Number(match[1].replace(',', '.'))
  const unit = (match[2] || 'g').toLowerCase()
  const multiplier = {
    k: BYTES_PER_KILOBYTE,
    m: BYTES_PER_MEGABYTE,
    g: BYTES_PER_GIGABYTE,
  }[unit]

  return Number.isFinite(amount) ? amount * multiplier : null
}

export function formatZipSize(bytes) {
  const value = Number(bytes)
  if (!Number.isFinite(value)) {
    return null
  }

  return (value / BYTES_PER_GIGABYTE)
    .toFixed(3)
    .replace(/\.?0+$/, '')
    .replace('.', ',')
}
